import {
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    ChangeDetectionStrategy,
    OnInit,
    SimpleChanges,
    Output,
    EventEmitter,
    ViewChild,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { NgxMaterialTimepickerComponent } from 'ngx-material-timepicker';
import { UtilsService } from '../utils/utils.service';

// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import _moment from 'moment/moment';
// eslint-disable-next-line no-duplicate-imports
import { default as _rollupMoment } from 'moment';
const moment = _rollupMoment || _moment;

@Component({
    selector: 'app-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.scss'],
})
export class DateTimePickerComponent implements OnInit, OnChanges {
    @Input() timestamp: number = null;
    @Input() changesAllowed = false;
    @ViewChild('datePicker') datePicker: MatDatepicker<moment.Moment>;
    @ViewChild('timePicker') timePicker: NgxMaterialTimepickerComponent;

    @Output() dateChanged = new EventEmitter<{ timestamp: number; finalChange: boolean }>();

    creationDateUTCString = '';
    creationDateTimeString = ''; // time in 24 hour format (e.g. 12:45)

    constructor(public utils: UtilsService) {}

    ngOnInit() {
        this.initCreationDate();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.initCreationDate();
    }

    /**
     * Initializes the creationDate picker
     */
    initCreationDate() {
        if (this.timestamp == null) {
            return;
        }
        // check "createdAt" date of job and prepare date picker
        this.creationDateUTCString = this.utils.timestampToIsoDateString(this.timestamp);
        this.creationDateTimeString = moment(this.timestamp).format('HH:mm'); // we have to set time default value here as the date-picker has no time and would just say 00:00 (so we handle date and time seperately)
    }

    onDateItemClicked() {
        if (this.changesAllowed) {
            this.datePicker.open();
        }
    }

    onDatePickerClosed(event) {
        let pickerVal = (this.datePicker.datepickerInput as any).value as moment.Moment;

        // after setting date, we automatically open time-picker
        this.timePicker.defaultTime = this.creationDateTimeString;
        this.timePicker.open();

        // even though we open the time-picker we emit the date now, because maybe user just wants to leave the time and exits but wants to take the changed data
        // we have to set hour and minute of our date for the final timestamp
        let timeSplit = this.creationDateTimeString.split(':');
        let emitDate = pickerVal.hour(parseInt(timeSplit[0])).minute(parseInt(timeSplit[1])).valueOf();
        this.dateChanged.emit({ timestamp: emitDate, finalChange: false }); // emit event in ms
    }

    onTimePickerUpdated(time: string) {
        let chosenTime = moment(time, 'HH:mm');
        // the property exists but for some reason was not typed in the lib
        let datePickerVal = (this.datePicker.datepickerInput as any).value as moment.Moment;

        datePickerVal = datePickerVal.set({
            hour: chosenTime.get('hour'),
            minute: chosenTime.get('minute'),
        });

        this.creationDateUTCString = this.utils.timestampToIsoDateString(datePickerVal.valueOf());
        this.creationDateTimeString = chosenTime.format('HH:mm');
        // and dont forget to update our form element

        this.dateChanged.emit({ timestamp: datePickerVal.valueOf(), finalChange: true }); // emit event in ms
    }
}
